// extracted by mini-css-extract-plugin
export default {"app":"home_app__RPByH","main":"home_main__9fnYY","title":"home_title__AAUTX"};